import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { QuickQuoteForm } from '../components/QuickQuoteForm';

export const MamografiaPage = () => {
  const equipment = {
    name: "Mamógrafo",
    subtitle: "Diagnóstico por Imagem da Mama",
    description: "Sistemas avançados de mamografia digital para rastreamento e diagnóstico de câncer de mama com qualidade de imagem superior. A mamografia digital oferece imagens de alta resolução com baixa dose de radiação.",
    image: "https://static.prod-images.emergentagent.com/jobs/7899ab28-0d6a-4e3b-b0e7-b178b443ae26/images/9d80e9162015b1fa445d0338921ed1f4ae69ef67c20426ecf7602c9e1ba31525.png",
    features: [
      "Imagem digital de alta resolução",
      "Baixa dose de radiação",
      "Capacidade de tomossíntese 3D",
      "Tempos de exame rápidos",
      "Compressão inteligente",
      "Detecção precoce de lesões"
    ],
    applications: [
      "Rastreamento de câncer de mama",
      "Diagnóstico de lesões suspeitas",
      "Acompanhamento pós-tratamento",
      "Avaliação de implantes",
      "Biópsias guiadas",
      "Tomossíntese mamária"
    ]
  };

  return (
    <div className="min-h-screen pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-600 via-blue-700 to-cyan-600 py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-6">
            <h1 className="text-4xl sm:text-5xl font-bold text-white">
              {equipment.name}
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              {equipment.subtitle}
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div>
              <div className="rounded-2xl overflow-hidden shadow-xl bg-gray-100 sticky top-32">
                <img 
                  src={equipment.image} 
                  alt={equipment.name}
                  className="w-full h-96 object-cover"
                />
              </div>
            </div>
            <div className="space-y-8">
              <p className="text-lg text-gray-600">
                {equipment.description}
              </p>
              
              <div className="space-y-3">
                <h3 className="font-semibold text-gray-900 text-xl">Características:</h3>
                <ul className="space-y-2">
                  {equipment.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start space-x-3">
                      <CheckCircle className="text-green-500 flex-shrink-0 mt-0.5" size={20} />
                      <span className="text-gray-600">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <Card className="bg-gray-50">
                <CardContent className="p-6">
                  <h3 className="font-semibold text-gray-900 mb-4 text-xl">Aplicações Clínicas:</h3>
                  <div className="grid grid-cols-2 gap-3">
                    {equipment.applications.map((app, idx) => (
                      <div key={idx} className="flex items-center space-x-2">
                        <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                        <span className="text-gray-700">{app}</span>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>

              <QuickQuoteForm equipmentName={equipment.name} />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-blue-600">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <div className="space-y-6">
            <h2 className="text-3xl sm:text-4xl font-bold text-white">
              Interessado em Mamografia?
            </h2>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto">
              Entre em contato para conhecer as opções disponíveis
            </p>
            <Link to="/contact">
              <Button size="lg" className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-6 text-lg">
                Fale Conosco
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
